import { Outlet } from "react-router";
import { useTypedParams } from "react-router-typesafe-routes";

import { ClientApplicationTabs } from "@components/Tabs";

import { Box } from "@design-system/Box/Box";

import { routes } from "@pages/routes";

export const Application = () => {
  const { clientId, applicationId } = useTypedParams(
    routes.portal.clients.client.applications.application,
  );

  return (
    <Box direction="column" gap={16} stretch>
      <Box stretch>
        <ClientApplicationTabs
          clientId={clientId}
          clientApplicationId={applicationId}
        />
      </Box>
      <Outlet />
    </Box>
  );
};
